import React, { CSSProperties } from 'react';
import styled from 'styled-components';

interface Props {
  height: string;
  width: string;
  style: CSSProperties;
  onClick: (e: any) => void;
}

const Icon = styled.svg`

  &:hover {
    cursor: pointer;
  }
`;

export const IconEllipsis = (props: Props) => {
  const { height, width, style, onClick } = props;

  return (
    <Icon height={height} width={width} style={style} onClick={onClick} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
    </Icon>
  );
};
